

export const KycVerificationListConstants = {
    GET_KYCVERIFICATION_LIST_REQUEST: "GET_KYCVERIFICATION_LIST_REQUEST",
    GET_KYCVERIFICATION_LIST_SUCCESS: "GET_KYCVERIFICATION_LIST_SUCCESS",
    GET_KYCVERIFICATION_LIST_FAILURE: "GET_KYCVERIFICATION_LIST_FAILURE",


    GET_KYC_EXPIRE_LIST_REQUEST: "GET_KYC_EXPIRE_LIST_REQUEST",
    GET_KYC_EXPIRE_LIST_SUCCESS: "GET_KYC_EXPIRE_LIST_SUCCESS",
    GET_KYC_EXPIRE_LIST_FAILURE: "GET_KYC_EXPIRE_LIST_FAILURE",

    GET_USERKYCDETAILS_LIST_REQUEST: "GET_USERKYCDETAILS_LIST_REQUEST",
    GET_USERKYCDETAILS_LIST_SUCCESS: "GET_USERKYCDETAILS_LIST_SUCCESS",
    GET_USERKYCDETAILS_LIST_FAILURE: "GET_USERKYCDETAILS_LIST_FAILURE",

    UPDATE_USER_KYCDETAILS_REQUEST: "UPDATE_USER_KYCDETAILS_REQUEST",
    UPDATE_USER_KYCDETAILS_SUCCESS: "UPDATE_USER_KYCDETAILS_SUCCESS",
    UPDATE_USER_KYCDETAILS_FAILURE: "UPDATE_USER_KYCDETAILS_FAILURE",


    GET_MERCHANT_KYC_LIST_REQUEST: "GET_MERCHANT_KYC_LIST_REQUEST",
    GET_MERCHANT_KYC_LIST_SUCCESS: "GET_MERCHANT_KYC_LIST_SUCCESS",
    GET_MERCHANT_KYC_LIST_FAILURE: "GET_MERCHANT_KYC_LIST_FAILURE",



}